import { render } from "./App.vue?vue&type=template&id=a7aeb50c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a7aeb50c&lang=scss"

import exportComponent from "/Users/admin/Repositories/dombois-windfilme/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__